import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';

import cls from 'classnames/bind';

import noop from 'lodash/noop';
import _padStart from 'lodash/padStart';

import { ANIMATION_TIME, DEFAULT_TIME } from '../../calendarConstants';

import scrollIntoView from 'scroll-into-view';

import s from './Time.scss';

const cx = cls.bind(s);
class Time extends PureComponent {
  static propTypes = {
    onContainerLeave: PropTypes.func.isRequired,
    onTimeHover: PropTypes.func,
    onTimeSelect: PropTypes.func,
    selectedTime: PropTypes.string,
    minTime: PropTypes.string,
    maxTime: PropTypes.string,
  };

  static defaultProps = {
    minTime: '00:00',
    maxTime: '23:30',
    onTimeHover: noop,
    onTimeSelect: noop,
  };

  constructor(props) {
    super(props);

    this.timesheet = this.createTimeSheet();
  }

  componentDidMount() {
    const targetNode = this[`${this.props.selectedTime || DEFAULT_TIME}-ref`];
    scrollIntoView(targetNode, {
      time: ANIMATION_TIME,
      validTarget: (target, parentsScrolled) => parentsScrolled < 1,
    });
  }

  createTimeSheet() {
    return Array.from(new Array(24)).reduce((acc, cur, h) => {
      const hour = _padStart(`${h}`, 2, '0');
      return acc.concat(`${hour}:00`, `${hour}:30`);
    }, []);
  }

  createTimeSelectHandler = (time) => () => {
    this.props.onTimeSelect(time);
  };

  createTimeHoverHandler = (time) => () => {
    this.props.onTimeHover(time);
  };

  createRef = (time) => (node) => {
    this[`${time}-ref`] = node;
  };

  checkIfInRange(time) {
    const times = [time, this.props.minTime, this.props.maxTime];
    const [intTime, intMinTime, intMaxTime] = times.map((timestr) => +timestr.replace(/:/, ''));

    return intTime >= intMinTime && intTime <= intMaxTime;
  }

  getTimeNodes() {
    return this.timesheet.map((time) => {
      const isSelected = this.props.selectedTime === time;
      const isDisabled = !this.checkIfInRange(time);

      const clickHandler = this.createTimeSelectHandler(time);
      const hoverHandler = this.createTimeHoverHandler(time);

      return (
        <li
          onClick={!isDisabled && clickHandler}
          onMouseEnter={!isDisabled && hoverHandler}
          key={time}
          ref={this.createRef(time)}
          className={cx('item', {
            'item--isDefault': !isSelected && !isDisabled,
            'item--isSelected': isSelected,
            'item--isDisabled': isDisabled,
          })}
        >
          {time}
        </li>
      );
    });
  }

  handleMouseLeave = () => {
    this.props.onContainerLeave();
  };

  render() {
    return (
      <ul className={cx('Time')} onMouseLeave={this.handleMouseLeave}>
        {this.getTimeNodes()}
      </ul>
    );
  }
}

export default Time;
